module.exports = __webpack_public_path__ + "img/clock-light.4d49c99b.svg";